import { PatientKind } from "common/types";

import {
  FilterDefinition,
  FilterValue,
  ProductLineSearchFilters,
  SelectedCategoryProductLineFilters,
  SelectedProductFilters,
  defineFilter,
} from "../types";

/** Options past this many collapse behind a "Show all" toggle. One column, so one row each. */
export const PANEL_COLLAPSED_OPTION_LIMIT = 6;

export const PANEL_OPTION_SEARCH_THRESHOLD = 12;

/** Divisible by both grid widths, so the last row is never short once the panel takes a column. */
export const DEFAULT_PAGE_SIZE = 24;

/** Filters offered on product results: search and deals. */
export const PRODUCT_FILTER_DEFINITIONS: FilterDefinition<SelectedProductFilters>[] = [
  defineFilter({
    key: "rebate",
    label: "Deals",
    singularLabel: "Deal",
    optionsFrom: (options) => options.rebates,
    selectedFrom: (filters) => filters.rebate_ids ?? [],
    toUpdate: (rebate_ids) => ({ rebate_ids }),
  }),
  defineFilter({
    key: "species",
    label: "Species",
    singularLabel: "Species",
    optionsFrom: (options) => options.species,
    selectedFrom: (filters) => filters.species,
    toUpdate: (species) => ({ species }),
  }),
  defineFilter({
    key: "category",
    label: "Categories",
    singularLabel: "Category",
    optionsFrom: (options) => options.categories,
    selectedFrom: (filters) => filters.category_ids,
    toUpdate: (category_ids) => ({ category_ids }),
  }),
  defineFilter({
    key: "manufacturer",
    label: "Manufacturers",
    singularLabel: "Manufacturer",
    optionsFrom: (options) => options.manufacturers,
    selectedFrom: (filters) => filters.manufacturer_ids,
    toUpdate: (manufacturer_ids) => ({ manufacturer_ids }),
  }),
  defineFilter({
    key: "prescription_required",
    label: "Type",
    singularLabel: "Type",
    optionsFrom: (options) => options.prescription_required,
    selectedFrom: (filters) => filters.prescription_required,
    toUpdate: (prescription_required) => ({ prescription_required }),
  }),
];

/**
 * Filters offered on the category page, which searches product lines. Category is absent because
 * the page is already scoped to one.
 */
export const CATEGORY_PRODUCT_LINE_FILTER_DEFINITIONS: FilterDefinition<
  SelectedCategoryProductLineFilters,
  FilterValue,
  ProductLineSearchFilters
>[] = [
  defineFilter<SelectedCategoryProductLineFilters, PatientKind, ProductLineSearchFilters>({
    key: "species",
    label: "Species",
    singularLabel: "Species",
    optionsFrom: (options) => options.species,
    selectedFrom: (filters) => filters.species,
    toUpdate: (species) => ({ species }),
  }),
  defineFilter<SelectedCategoryProductLineFilters, number, ProductLineSearchFilters>({
    key: "manufacturer",
    label: "Manufacturers",
    singularLabel: "Manufacturer",
    optionsFrom: (options) => options.manufacturers,
    selectedFrom: (filters) => filters.manufacturer_ids,
    toUpdate: (manufacturer_ids) => ({ manufacturer_ids }),
  }),
  defineFilter<SelectedCategoryProductLineFilters, boolean, ProductLineSearchFilters>({
    key: "prescription_required",
    label: "Type",
    singularLabel: "Type",
    optionsFrom: (options) => options.prescription_required,
    selectedFrom: (filters) => filters.prescription_required,
    toUpdate: (prescription_required) => ({ prescription_required }),
  }),
];
